.two { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.gauges { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.gauge { display: flex; flex-direction: column; align-items: center; gap: 2px; min-width: 0; text-align: center; }
.gauge svg { display: block; max-width: 100%; }
.gauge b { max-width: 100%; font-weight: var(--fw-label); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.gauge span { max-width: 100%; font-size: 12px; color: var(--lb); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chip { flex: none; padding: 2px 9px; border-radius: 999px; font-size: 12px; font-weight: var(--fw-label); white-space: nowrap; }
.row { display: flex; align-items: center; gap: 10px; min-height: 40px; min-width: 0; }
.row + .row { border-top: 1px solid var(--line); }
.row .k { flex: 1; min-width: 0; color: var(--tx2); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.row .v { font-weight: var(--fw-label); white-space: nowrap; }
.row small { display: block; font-size: 12px; color: var(--lb); font-weight: 400; }
.sel { background: var(--pri-bg); }
@media (max-width: 1100px) { .two { grid-template-columns: minmax(0, 1fr); } }
